export default "__VITE_ASSET__Df1zo6Zk__"